const hasGrade = (grade) => grade !== undefined && grade !== null;

const hasAnyGrade = (grades) => {
  for (let i = 0; i < grades.length; i += 1) {
    if (hasGrade(grades[i].grade)) {
      return true;
    }
  }

  return false;
};

export default hasAnyGrade;
